import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const PageHeader = ({ children, className, classes, fixed }) => {
  const { themeClasses } = useThemePresetClasses("PageHeader", classes, className);
  return /* @__PURE__ */ jsx(
    "header",
    {
      className: cn(
        "flex-shrink-0",
        {
          "fixed left-0 top-0 h-fit w-full": fixed
        },
        themeClasses == null ? void 0 : themeClasses.root
      ),
      children
    }
  );
};
const PageHeader$1 = PageHeader;
export {
  PageHeader$1 as default
};
